var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mt-3",domProps:{"textContent":_vm._s(_vm.info.name)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }